'use client';

import { FC } from 'react';

import { useScroll } from 'hooks/useScroll';

import { GoBackBtn } from './GoBackBtn';
import { useAuth } from 'contexts/auth';
import { MEMBER_ROUTES } from 'utils/routes';
import { Button } from 'components/ui/button';
import { useRouter } from 'next/navigation';


type IProfileEditHeader = {
  userId: string
  onFinish: () => boolean
}

export const ProfileEditHeader: FC<IProfileEditHeader> = (props: IProfileEditHeader) => {
  const { isScrolled } = useScroll();
  const { reFetchCurrentUser } = useAuth();
  const router = useRouter();

  return (
      <div className={`md:py-3 flex md:px-4 mb-5 items-center justify-between md:sticky top-0 bg-gray-50 z-50 ${isScrolled ? 'md:shadow-md transition-shadow' : ''}`}>
        <GoBackBtn onclick={ reFetchCurrentUser} />
        <h1 className='text-large text-brand-950 font-bold'>My Profile</h1>
        <Button
          variant='black'
          onClick={() => {
            if (props.onFinish()) {
              reFetchCurrentUser();
              router.refresh();
              router.push(`${MEMBER_ROUTES.MEMBER_PROFILE.getPath(props.userId)}?fnsh=true`);
            }
          }}
        >
          Preview
        </Button>
      </div>
  );
};
